import {ApiClient} from '@hconnect/apiclient'
import {StoppageCreate} from '@hconnect/common/stoppages/types/stoppage.types'
import {StoppageDto as Stoppage} from '@hconnect/common/types'
import {useMutation, UseMutationOptions, useQueryClient} from '@tanstack/react-query'
import {AxiosError} from 'axios'

import {prepareStoppagePayload} from '../utils'

const createStoppage = async (plantId: string, event: StoppageCreate) => {
  const formData = await prepareStoppagePayload(event)
  const path = `/shifthandover/${plantId}/stoppages`

  const response = await ApiClient.axiosInstance.post<Stoppage>(path, formData)
  return response.data
}

export const useStoppageCreate = (
  plantId: string,
  options?: UseMutationOptions<Stoppage, AxiosError, StoppageCreate>
) => {
  const queryClient = useQueryClient()

  return useMutation({
    mutationFn: (event: StoppageCreate) => {
      return createStoppage(plantId, event)
    },
    ...options,
    onSuccess: async (data, variables, context, mutation) => {
      await queryClient.invalidateQueries()
      await options?.onSuccess?.(data, variables, context, mutation)
    },
    onError: (error, ...args) => {
      // eslint-disable-next-line @typescript-eslint/no-floating-promises
      options?.onError?.(error, ...args)
    }
  })
}
